import script from "./InvitationValidation.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationValidation.vue?vue&type=script&setup=true&lang=js"

import "./InvitationValidation.vue?vue&type=style&index=0&id=e15f79b6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e15f79b6"]])

export default __exports__